'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = addressForm;

var _lodash = require('lodash');

var _presentation = require('../actions/presentation');

var _pickupLocations = require('../actions/pickupLocations');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  useShipping: true,
  addressDetails: {
    email: '',
    cpf_number: '',
    ship: {
      firstName: '',
      lastName: '',
      phone: '',
      address1: '',
      address2: '',
      city: '',
      state_name: '',
      company: '',
      zipcode: '',
      housenumber: '',
      location_code: '',
      postcodeLookupVisible: true,
      lookupAddressIsSelected: false,
      lookupAddressRecord: ''
    },
    bill: {
      firstName: '',
      lastName: '',
      phone: '',
      address1: '',
      address2: '',
      city: '',
      state_name: '',
      company: '',
      zipcode: '',
      housenumber: '',
      postcodeLookupVisible: true,
      lookupAddressIsSelected: false,
      lookupAddressRecord: ''
    }
  }
};

var updateShippingAddress = function updateShippingAddress(details, updated) {
  var newState = (0, _lodash.cloneDeep)(details);
  var ship = newState.ship;

  ship.firstName = 'Collection Point';
  ship.lastName = '';
  ship.phone = 'N/A';
  ship.address1 = updated.name;
  ship.address2 = updated.address;
  ship.city = updated.city;
  ship.state_name = updated.county || updated.city;
  ship.zipcode = updated.postcode;
  ship.location_code = updated.vendor_id;

  return newState;
};

function addressForm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var details = void 0;
  switch (action.type) {
    case 'TOGGLE_USE_SHIPPING':
      return (0, _extends3.default)({}, state, { useShipping: !state.useShipping });
    case 'SAVE_ADDRESS_DETAILS_IN_FORM':
      details = state.addressDetails;
      details[action.prefix][action.fieldName] = action.value;

      return (0, _extends3.default)({}, state, { addressDetails: details });
    case 'SAVE_EMAIL_IN_ADDRESS_DETAILS_FORM':
      details = state.addressDetails;
      details.email = action.value;

      return (0, _extends3.default)({}, state, { addressDetails: details });
    case 'SAVE_CPF_NUMBER_IN_ADDRESS_DETAILS_FORM':
      details = state.addressDetails;
      details.cpf_number = action.value;

      return (0, _extends3.default)({}, state, { addressDetails: details });
    case 'ENABLE_POSTCODE_LOOKUP':
      details = state.addressDetails;
      details[action.prefix].postcodeLookupVisible = true;

      return (0, _extends3.default)({}, state, { addressDetails: details });
    case 'DISABLE_POSTCODE_LOOKUP':
      details = state.addressDetails;
      details[action.prefix].postcodeLookupVisible = false;

      return (0, _extends3.default)({}, state, { addressDetails: details });
    case _presentation.SET_CLICK_AND_COLLECT:
      if (!action.enable) {
        return (0, _extends3.default)({}, state, {
          addressDetails: INITIAL_STATE.addressDetails,
          useShipping: true
        });
      }

      return (0, _extends3.default)({}, state, { useShipping: false });
    case _pickupLocations.CONFIRM_PICKUP_LOCATION:
      return (0, _extends3.default)({}, state, {
        addressDetails: updateShippingAddress(state.addressDetails, action.details)
      });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/addressForm.js
// module id = 2344
// module chunks = 0